import { makeStyles } from '@material-ui/core/styles';
import React, { useState } from 'react';
import {
    List,
    ListItem,
    ListItemText,
    Collapse,
    IconButton,
    Box,
    Checkbox,
    Tooltip
} from '@material-ui/core';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    groupTitle: {
        backgroundColor: '#c5c5c578',
        marginTop: '3px',
        marginBottom: '3px',
        color: theme.palette.primary.main,
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: '#f0f0f0',
        },
    },
    nodeHeader: {
        display: 'flex',
        '& span': {
            fontSize: 'larger',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
        },
    },
    buttonExpand: {
        marginRight: '22px',
        marginTop: '12px'
    }
}));

const GroupItem = ({
    element,
    selectedValues = [],
    onToggle,
    groupTitleKey,
    setGroupTitleKey,
    objectCatalog,
    hasSomeVirtualNodes,
    dataset,
    forceOpen = false
}) => {
    const classes = useStyles();
    const [open, setOpen] = useState(forceOpen || element.key === groupTitleKey);

    const handleArrows = () => {
        if (forceOpen) return;
        if (element.key === groupTitleKey) {
            setOpen(!open);
        } else {
            setOpen(true);
            setGroupTitleKey(element.key);
        }
    };

    const isChecked = (item) =>
        Boolean(
            selectedValues?.some(v =>
                typeof v === 'object'
                    ? v.key === item.key
                    : v === item.key
            )
        );


    const hasAutomateVars = () =>
        element.children?.some(v => v.client_var);

    const isItemDisabled = (item) => {
        if (item.node === 'FISICO' && hasSomeVirtualNodes()) {
            return true;
        }

        if (
            dataset?.variables?.length > 0 &&
            objectCatalog[dataset?.variables?.[0]]?.endpoint_key !== item?.endpoint?.key
        ) {
            return true;
        }

        return false;
    };


    return (
        <Box width="100%" className={classes.root}>

            {!forceOpen && (
                <Box display="flex" className={classes.groupTitle} onClick={handleArrows}>
                    <ListItem>
                        <ListItemText
                            primary={element.name}
                            className={classes.nodeHeader}
                        />
                        {hasAutomateVars() && (
                            <Tooltip title="Automate asociado">
                                <IconButton edge="end">
                                    <PrecisionManufacturingIcon />
                                </IconButton>
                            </Tooltip>
                        )}
                    </ListItem>

                    <Box width={30} className={classes.buttonExpand}>
                        {open ? <ExpandLess /> : <ExpandMore />}
                    </Box>
                </Box>
            )}

            <Collapse in={forceOpen || open} timeout="auto" unmountOnExit>
                <List dense disablePadding>
                    {element.children.map(child => (
                        <ListItem
                            key={child.key}
                            button
                            disabled={isItemDisabled(child)}
                            onClick={() => onToggle(child, !isChecked(child))}
                        >
                            <Checkbox
                                checked={isChecked(child)}
                                disabled={isItemDisabled(child)}
                                tabIndex={-1}
                                disableRipple
                                color='primary'
                                onChange={(e) =>
                                    onToggle(child, e.target.checked)
                                }
                            />
                            <ListItemText
                                className={classes.nodeHeader}
                                primary={child.tag || child.name}
                            />
                        </ListItem>
                    ))}
                </List>
            </Collapse>

        </Box>
    );
};

export default GroupItem;
